module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img@2x.4677bd5f.webp";